// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"MyBalance__balanceWrapper--U6w","balance":"MyBalance__balance--3vr","balanceLow":"MyBalance__balanceLow--1dy","icon":"MyBalance__icon--J8G"};